import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import { useEffect, useRef, useState } from "react";
import { formatMoeda, getNumeroNota, getUuidV4, goToFocus, handleNumberOnly, isNumber } from "../../../../utils/utils";
import { removeNFe, addNFe, updateNFe, clearNFe } from "../../../../features/manifestoSlice"
import { Button, Card, Col, Dropdown, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBox, faBuilding, faEllipsis, faGear, faPlus, faSave, faXmark
} from "@fortawesome/free-solid-svg-icons";
import { ButtonEditar, ButtonRemover, ButtonTrash, JTable, JTBody, JTHead, JvCaption, SpanIcon } from "../../../../components/Components";
import { infMunDescargaInterface, infNFesInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import NFesProdutoPerigoso from "./NFesProdutoPerigoso";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { Link } from "react-router-dom";
import NFesUnidadeTransp from "./NFesUnidadeTransp";

const initialForm: infNFesInterface = {
    chNFe: '',
    SegCodBarra: '',
    municipio_id: 0,
    name: '',
    indReentrega: false,
    peri: [],
    infUnidTransp: [],
    id: 0
}

interface ValueDelete extends SelectObjectRemoveInterface {
    idNFe: number | string;
}

const LIMITE: number = 10000;

const NFes: React.FC = () => {
    const dispatch = useDispatch();
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [saldo, setSaldo] = useState<number>(0);
    const [notaFiscal, setNotaFiscal] = useState<infNFesInterface>(initialForm);
    const [showProdutoPerigoso, setShowProdutoPerigoso] = useState<boolean>(false);
    const [showUnidadeTransporte, setShowUnidadeTransporte] = useState<boolean>(false);
    const [change, setChange] = useState<boolean>(false);
    const munNFeSelectRef = useRef<HTMLSelectElement>(null);
    const manifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const munDescarga = useSelector((state: RootState) => state.manifesto.manifesto.infMunDescarga);
    const selectMunicipiosDescarregamento = useSelector((state: RootState) =>
        state.manifesto.selectMunicipiosDescarregamentos);
    const [idNfe, setIdNfe] = useState<number | string>(0)
    const [selecionado, setSelecionado] = useState<number | string>('');
    const chNFeRef = useRef<HTMLInputElement>(null)
    const segCodBarraRef = useRef<HTMLInputElement>(null)

    const handleNFeChange = (e: any) => {
        const { name, value } = e.target;
        setNotaFiscal((prev) => ({ ...prev, [name]: value }))
    }

    const validaPreenchimentoNFe = () => {

        if (manifesto.indcarregaposterior === true) {
            alertModal('Não é permitido adicionar município quando Ind. Carregamento Posterior estiver marcado.');
            return;
        }

        if (notaFiscal.chNFe === "") {
            goToFocus(chNFeRef)
            alertModal('Informe uma chave NFe.');
            return false;
        }

        if (!isNumber(notaFiscal.chNFe)) {
            goToFocus(chNFeRef)
            alertModal('Chave NF-e aceita somente números.');
            return false;
        }

        if (notaFiscal.SegCodBarra?.trim() !== "") {
            if (!isNumber(notaFiscal.SegCodBarra?.trim().toString())) {
                goToFocus(segCodBarraRef)
                alertModal('Seg. Cod. Barras aceita somente números.');
                return false;
            }
        }

        if (notaFiscal.chNFe.substring(20, 22) !== '55') {
            goToFocus(chNFeRef)
            alertModal('Chave informada não é uma NF-e.');
            return false;
        }

        if (notaFiscal.chNFe.length !== 44) {
            goToFocus(chNFeRef)
            alertModal('Chave deve conter 44 caracteres.');
            return false;
        }

        if (munDescarga.flatMap((item: any) => item.infNFe).find((item: infNFesInterface) =>
            item.chNFe === notaFiscal.chNFe && item.id !== notaFiscal.id)) {
            goToFocus(chNFeRef)
            alertModal('Chave já foi adicionada.');
            return false;
        }

        if (munDescarga.flatMap((item: any) => item.infNFe).length >= LIMITE) {
            alertModal(`Limite de ${formatMoeda(LIMITE, 0)} NF-e atingido.`);
            return false;
        }

        return true;
    }

    const handleRemover = async (value: ValueDelete) => {
        if (change) {
            alertModal('Existem alterações não salvas.');
            return;
        }

        setSelecionado(value.idNFe);
        const confirmed = await confirm({
            message: <>Remover NF-e: <strong>{getNumeroNota(value.title)}</strong> ?</>,
            title: "Confirmação"
        });
        if (confirmed) {
            dispatch(removeNFe({ municipio_id: parseInt(value.id.toString()), id: value.idNFe }));

        }
        setSelecionado('');
    }

    const handleRemoverTudo = async () => {
        if (change) {
            alertModal('Existem alterações não salvas.');
            return;
        }

        if (munDescarga.flatMap((item) => item.infNFe).length > 0) {
            const confirmed = await confirm({
                message: <>Remover todas as NF-e ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(clearNFe());
            }
        }
    }

    const handleAdd = () => {
        if (munNFeSelectRef.current && munNFeSelectRef.current?.value !== "") {
            const nomeMunicipio = munNFeSelectRef.current?.options[munNFeSelectRef.current?.selectedIndex].text || ''

            if (validaPreenchimentoNFe()) {

                dispatch(addNFe({
                    ...notaFiscal,
                    id: getUuidV4(),
                    name: nomeMunicipio,
                    municipio_id: parseInt(munNFeSelectRef.current?.value)
                }));

                setNotaFiscal(initialForm);
                setShowProdutoPerigoso(false);
            }

        } else {
            alertModal("Selecione um município.");
            return;
        }
    }

    const loadNFe = (id: number | string, municipio_id: number, chNFe: string) => {
        if (change) {
            alertModal('Existem alterações não salvas.');
            return;
        } else {
            const municipio = manifesto.infMunDescarga.find((item: any) => item.municipio_id === municipio_id);
            const nfe = municipio?.infNFe?.find((item: infNFesInterface) => item.chNFe === chNFe);
            setNotaFiscal({ ...notaFiscal, ...nfe, municipio_id: municipio_id, name: municipio?.name });
            setChange(true);
            setSelecionado(id);
        }
    }

    const handleUpdate = () => {
        if (validaPreenchimentoNFe()) {
            dispatch(updateNFe({
                ...notaFiscal,
                name: munNFeSelectRef.current?.options[munNFeSelectRef.current?.selectedIndex].text || ''
            }));
            setNotaFiscal(initialForm);
            setChange(false);
            setShowProdutoPerigoso(false);
            setSelecionado('');
        }
    }

    const handleCancelarEdicao = () => {
        setChange(false);
        setSelecionado('');
        setNotaFiscal(initialForm);
    }

    const handleCloseProdutoPerigoso = () => {
        setShowProdutoPerigoso(false);
        setSelecionado('');
    }

    const handleShowProdutoPerigoso = (id: number | string) => {
        if (change) {
            alertModal('Existem alterações não salvas.');
        } else {
            setIdNfe(id);
            setShowProdutoPerigoso(true);
            setSelecionado(id);

        }
    }


    const handleCloseUnidadeTransp = () => {
        setShowUnidadeTransporte(false);
        setSelecionado('');
    }

    const handleShowUnidadeTransporte = (id: number | string) => {
        if (change) {
            alertModal('Existem alterações não salvas.');
        } else {
            setIdNfe(id);
            setShowUnidadeTransporte(true);
            setSelecionado(id);
        }
    }

    useEffect(() => {
        if (munDescarga?.length > 0) {
            setNotaFiscal((prev) => ({ ...prev, municipio_id: munDescarga[0].municipio_id }))
        }

    }, [munDescarga, manifesto.modal]);

    useEffect(() => {
        const total = (munDescarga ?? []).reduce((acc: number, item: infMunDescargaInterface) => {
            return acc + (item.infNFe?.length ?? 0);
        }, 0);
        setSaldo(total);

    }, [munDescarga])

    return (<>
        <Card className="mb-2">
            <Card.Header className="fw-bold">
                Formulário de inclusão da NF-e
            </Card.Header>

            <Card.Body>
                <Row className="g-2 mb-3">
                    <Col md={4}>
                        <Form.Group controlId="nfe-municipio_id">
                            <Form.Label>*Municipios</Form.Label>
                            <Form.Select name="municipio_id" value={notaFiscal.municipio_id}

                                onChange={handleNFeChange} ref={munNFeSelectRef}>
                                {selectMunicipiosDescarregamento?.map(item => {
                                    return (<option key={item.id} value={item.id}>{item.name}</option>);
                                })}
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="nfe-chNFe">
                            <Form.Label>*Chave NF-e</Form.Label>
                            <Form.Control name="chNFe" value={notaFiscal.chNFe}
                                ref={chNFeRef}
                                onKeyUp={handleNumberOnly} type="text" maxLength={44}
                                onChange={handleNFeChange} />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group controlId="nfe-SegCodBarra">
                            <Form.Label>Seg. Cod. Barras</Form.Label>
                            <Form.Control name="SegCodBarra" value={notaFiscal.SegCodBarra} maxLength={36}
                                ref={segCodBarraRef}
                                onKeyUp={handleNumberOnly} type="text" onChange={handleNFeChange} />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="g-2">

                    <Col md={'auto'} className="d-flex align-items-end ">
                        <Form.Group >
                            <Form.Switch className="mb-0" type="switch" name="active" label="ind. Reentrega?"
                                checked={notaFiscal.indReentrega}
                                onChange={(e) => setNotaFiscal({ ...notaFiscal, indReentrega: e.target.checked })} />
                        </Form.Group>
                    </Col>

                </Row>

            </Card.Body>
            <Card.Footer>
                <Button className="active me-2" variant="primary"
                    disabled={change}
                    onClick={handleAdd}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>

                {change && (<>
                    <Button className="active me-2" variant="success"
                        disabled={!change}
                        onClick={handleUpdate}>
                        <FontAwesomeIcon icon={faSave} /> Salvar
                    </Button>

                    <Button className="active me-2" variant="danger"
                        disabled={!change}
                        onClick={handleCancelarEdicao}>
                        <FontAwesomeIcon icon={faXmark} /> Cancalar
                    </Button>
                </>)}

            </Card.Footer>
        </Card>
        <JTable >

            <JvCaption>({saldo} de {formatMoeda(LIMITE, 0, 'decimal')} no máximo)</JvCaption>
            <JTHead >
                <tr>
                    <th className="text-center" style={{ width: '4rem' }}>
                        <ButtonTrash onClick={() => handleRemoverTudo()} />
                    </th>
                    <th>Municipio</th>
                    <th>Chave NF-e</th>
                    <th>Seg. Cod. Barras</th>
                    <th className="text-center" style={{ width: '2.5rem' }}>
                        <FontAwesomeIcon className="text-primary" icon={faGear} />
                    </th>
                </tr>
            </JTHead>
            <JTBody>
                {munDescarga?.map((item: infMunDescargaInterface) => (
                    <>
                        {item.infNFe?.map((nfe: infNFesInterface) => {
                            return (
                                <tr key={nfe?.id} className={(nfe.id?.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                    <td className="d-flex justify-content-around ">
                                        <ButtonRemover onClick={() => handleRemover({ id: item.municipio_id, title: nfe?.chNFe, idNFe: nfe.id ?? '' })} />
                                        <ButtonEditar onClick={() => loadNFe(nfe.id?.toString() ?? '', item.municipio_id, nfe?.chNFe)} />
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{nfe.chNFe}</td>
                                    <td>{nfe?.SegCodBarra}</td>
                                    <td className="text-center p-0 m-0">
                                        <Dropdown className="d-grid gap-2"  >
                                            <Dropdown.Toggle id="dropdown-basic" size="sm" title="Opções"
                                                variant=""
                                                className="no-caret rounded-1 btn btn-sm">
                                                <FontAwesomeIcon icon={faEllipsis} />
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item as={Link} to={``}
                                                    onClick={() => handleShowProdutoPerigoso(nfe?.id?.toString() ?? 0)}>
                                                    <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faBuilding}
                                                        className="text-primary me-1" />
                                                    <SpanIcon count={nfe?.peri?.length ?? 0} />
                                                    Produtos Perigosos ONU
                                                </Dropdown.Item>
                                                <Dropdown.Item as={Link} to={``}
                                                    onClick={() => handleShowUnidadeTransporte(nfe?.id?.toString() ?? 0)}>
                                                    <FontAwesomeIcon style={{ minWidth: '1.25rem' }} icon={faBox}
                                                        className="text-info me-1" />
                                                    <SpanIcon count={nfe?.infUnidTransp?.length ?? 0} />
                                                    Unidades de Transporte
                                                </Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            )
                        })}
                    </>
                ))}
            </JTBody>
        </JTable>
        <NFesProdutoPerigoso show={showProdutoPerigoso} handleClose={handleCloseProdutoPerigoso} id={idNfe} />
        <NFesUnidadeTransp show={showUnidadeTransporte} handleClose={handleCloseUnidadeTransp} id={idNfe} />
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}
export default NFes;
